import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Sparkles } from 'lucide-react';
import { BlogPost, blogPosts } from '../../data/blog';
import { BlogCard } from '../BlogCard';
import { Button } from '../ui/Button';
interface RelatedArticlesProps {
  currentPostId: string;
  category: string;
}
export function RelatedArticles({
  currentPostId,
  category
}: RelatedArticlesProps) {
  // Smart recommendation logic (mocked)
  const related = blogPosts.filter(post => post.category === category && post.id !== currentPostId).slice(0, 3);
  if (related.length === 0) return null;
  return <section className="py-16 border-t border-gray-100 mt-16 bg-gradient-to-b from-white to-[#FAF7F2]/50 -mx-4 px-4 sm:-mx-8 sm:px-8 lg:-mx-12 lg:px-12 rounded-b-[3rem]" data-id="element-749">
      <div className="flex flex-col md:flex-row items-end justify-between mb-10 gap-4" data-id="element-750">
        <div data-id="element-751">
          <span className="inline-flex items-center gap-2 text-[#7C9885] font-bold text-sm uppercase tracking-wider mb-2" data-id="element-752">
            <Sparkles className="h-4 w-4" data-id="element-753" />
            Recomendado para ti
          </span>
          <h2 className="text-3xl font-bold text-[#2C3333]" data-id="element-754">
            Sigue leyendo sobre {category}
          </h2>
        </div>
        <Link to="/blog" data-id="element-755">
          <Button variant="outline" className="group" data-id="element-756">
            Ver todo el blog
            <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" data-id="element-757" />
          </Button>
        </Link>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-758">
        {related.map((post, idx) => <div key={post.id} className="relative" data-id="element-759">
            {idx === 0 && <div className="absolute -top-3 left-4 z-10 bg-[#2C3333] text-white text-[10px] font-bold px-3 py-1 rounded-full shadow-lg uppercase tracking-wide" data-id="element-760">
                Mejor coincidencia
              </div>}
            <BlogCard post={post} index={idx} data-id="element-761" />
          </div>)}
      </div>
    </section>;
}